module.exports = __webpack_public_path__ + "media/images/exclamation_mark-d43db12712f798c72963fe5517b179d9.png";